export const prepareData = (event, player) => {
    let isMobile = window.matchMedia("(pointer:coarse)").matches;
    const currentT = Math.round(player.currentTime());
    const xApp = isMobile ? "mobile" : "internet";
    let data = {
        "type": isMobile ? "mobile" : "internet",
        "x-event": event,
        // "duration": player.duration(),
        "duration": 0,
        timecode: currentT,
        "currentTime": currentT,
        "c-proto": "http",
        client: player.stats_res?.client,
        user_id: "4f46e3de-0870-48d7-adde-281a31463127",
        unique_id: "",
        new_user: false,
        "c-referrer": "fo-player-prodparcoursmetiers.webtv-solution.com/pujausm13SoKaVmPBrB7Sb91Oa89VCspJHe3b4rDc1Xs_Iwb8ooP9kOfggeDELcTvzSDb0peIf6h2Th3lZnd3Q?autoplay=1",
        "c-user-agent": window.navigator.userAgent,
        "x-app": player?.stats_res["x-app"] ? player.stats_res["x-app"] : xApp,
        v: player.stats_res.v,
        "c-ip": player.stats_res["c-ip"],
        "s-port": player.stats_res["s-port"],
        "s-ip": player.stats_res["s-ip"],
        "x-duration": currentT,
        autoplay: false,
        seekCount: player.seekCount,
        pauseCount: player.pauseCount,
        bufferCount: "0",
        bufferDuration: "0",
        watchedDuration: "0",
        initialLoadTime: "0",
        secondsToLoad: "0",
        stats_url: player.stats_res.stats_url,
        recentDuration: "0",
        host: "",
        channels: player.stats_res.channels,
        themes: player.stats_res.themes,
        email: "",
        entity: "",
        "x_file_name": player.videoTitle
    };
    if (currentT == 0 && data["x-event"] == "play") {
        data['x-event'] = "firstplay";
        data.firstPlay = true
    }
    return data;
}


export const service = async (data) => {
    var formBody = [];
    for (var property in data) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(data[property]);
        formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");
    return await fetch(
        `https://stats.webtv-solution.com/webtv/logs/viewing/${data.type}`,
        {
            body: formBody,
            method: "POST",
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            }
        }

    )
}
